import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [
  // {
  //   path: '/main',
  //   name: 'Main',
  //   component: () => import('../views/index.vue'),
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '/patient',
    name: 'Patient',
    redirect: '/registered',
    component: () => import('../views/patient/index.vue'),
    children: [
      {
        path: '/hospitalInfo',//健康信息
        name: 'HospitalInfo',
        component: () => import('../views/patient/hospitalInfo.vue')
      },
      {
        path: '/registered',//预约挂号
        name: 'Registered',
        component: () => import('../views/patient/registered/index.vue')
      },
      {
        path: '/registeredRecord',//挂号记录
        name: 'registeredRecord',
        component: () => import('../views/patient/inquire/registeredRecord.vue')
      },
      {
        path: '/medicalRecord',//就诊记录
        name: 'MedicalRecord',
        component: () => import('../views/patient/inquire/medicalRecord.vue')
      },
      {
        path: '/prescriptionQuery',//处方查询
        name: 'PrescriptionQuery',
        component: () => import('../views/patient/inquire/prescriptionQuery.vue')
      },
      {
        path: '/costQuery',//费用查询
        name: 'CostQuery ',
        component: () => import('../views/patient/inquire/costQuery.vue')
      },
      {
        path: '/onlineConsulting',//网上咨询
        name: 'OnlineConsulting ',
        component: () => import('../views/patient/serve/onlineConsulting.vue')
      },
      {
        path: '/onlineComplaints',//网上投诉
        name: 'OnlineComplaints ',
        component: () => import('../views/patient/serve/onlineComplaints.vue')
      }
    ]

  },
  ];

const router = createRouter({
    base: '/portal-patient/',
    history: createWebHashHistory(),
    routes, // `routes: routes` 的缩写
});

router.beforeEach((to, from, next) => {
    // TODO 全局路由守卫
    from;
    if (to.name !== 'Login' && !sessionStorage.getItem('Authorization')){
      next({ name: 'Login' });
    } 
    next();
});

export default router;